<modal-popup
  [flexible]="true"
  [focusOnOpen]="true"
  [isOpen]="true"
  (onClose)="close()"
  title="{{ 'translate.cat.addSpellingCheckIgnored' | translate }}"
>
  <div class="container">
    <div>
      <input-wrap
        label="{{ 'translate.general.spellingCheckIgnoredWord' | translate }}"
        cssClass="l-cell-spread"
        [required]="true"
      >
      <input
        type="text"
        [(ngModel)]="spellingCheckIgnoredWord"
        class="t-input"
      />
      </input-wrap>

      <div class="t-panel-cell t-buttonSet l-align-spaceBetween l-mar-top">
        <checkbox-wrap class="checkbox" label="{{ 'translate.general.useGlobally' | translate }}">
          <input type="checkbox" [(ngModel)]="useGlobally" />
        </checkbox-wrap>

        <button
          [disabled]="!spellingCheckIgnoredWord"
          (click)="add()"
          class="t-button-outline"
        >
          {{ "translate.general.add" | translate }}
        </button>
      </div>
    </div>
  </div>
</modal-popup>
